<script lang="ts">
	export let dark = false;
	export let tableRowRef: HTMLElement = null;
	export let withHover = true;
</script>

<tr
	class={`table-row ${$$props.class}`}
	class:withHover
	class:dark
	bind:this={tableRowRef}
	on:click
>
	<slot />
</tr>

<style lang="scss">
	@import 'tableRow';
</style>
